import React, { ReactElement } from 'react';

import { ContractTermsTitle } from 'pricing/components/contractTerms/ContractTerms.styles';
import AddContractTerm from 'pricing/components/contractTerms/addContractTerm/AddContractTerm';
import ContractTermForm from 'pricing/components/contractTerms/contractTermForm/ContractTermForm';
import ContractTermsTable from 'pricing/components/contractTerms/contractTermsTable/ContractTermsTable';
import { useContractState } from 'pricing/components/contract/useContractState/useContractState';
import UploadContractAmendment from 'pricing/components/contract/uploadContractAmendment/UploadContractAmendment';
import {
  isContractCreateMode,
  isContractEditMode,
} from 'pricing/utilities/contract/contractMode/contractMode';

function ContractTerms(): ReactElement {
  const { state } = useContractState();
  const { contract, contractMode, amendmentFileUpload } = state;
  const contractTerms = contract?.breederContractTerms || [];

  return (
    <section className="ContractTerms">
      <ContractTermsTitle>
        Contract Terms
        {isContractEditMode(contractMode) && !amendmentFileUpload && (
          <UploadContractAmendment />
        )}
      </ContractTermsTitle>
      {isContractEditMode(contractMode) && amendmentFileUpload && <AddContractTerm />}
      {isContractCreateMode(contractMode) && <AddContractTerm />}
      {contract?.breederContractTerms && (
        <ContractTermsTable
          contractTerms={contractTerms}
          withActions={Boolean(amendmentFileUpload) || isContractCreateMode(contractMode)}
        />
      )}
      <ContractTermForm />
    </section>
  );
}

export default ContractTerms;
